import { ConsultantHeroImage, HomeHeroImage } from "assets/images";
import {
  ConsultantHero720Webp,
  ConsultantHero1200Webp,
  ConsultantHero2468Webp,
  ConsultantHero720Png,
  ConsultantHero1200Png,
  ConsultantHero2468Png,
} from "assets/images";
import {
  FaqSection,
  FeatureSection,
  HeroSection,
  OngoingProjectSection,
  PartnerSection,
} from "components";
import { FC } from "react";
import { features } from "./constant";

export const ConsultantPage: FC = () => {
  return (
    <>
      <HeroSection
        title="Gain Access to an endless stream of project briefs"
        subtitle="Sign up and get your company's profile in front of hundreds of project owners for free."
        imageSrc={ConsultantHero1200Png}
        imageWebpSrcSet={[
          `${ConsultantHero720Webp} 720w`,
          `${ConsultantHero1200Webp} 1200w`,
          `${ConsultantHero2468Webp} 2468w`,
        ].join(", ")}
        imageFallbackSrcSet={[
          `${ConsultantHero720Png} 720w`,
          `${ConsultantHero1200Png} 1200w`,
          `${ConsultantHero2468Png} 2468w`,
        ].join(", ")}
        imageWidth={2468}
        imageHeight={1472}
      />
      <PartnerSection />
      <FeatureSection features={features} />
      <OngoingProjectSection />
      <FaqSection />
    </>
  );
};
